import { ManagementPage } from "../components/common/ManagementPage";

const truckFields = [
  { name: "truck_number", label: "Truck number", required: true, placeholder: "205" },
  { name: "unit_number", label: "Unit number", placeholder: "U205" },
  { name: "plate_number", label: "Plate number", required: true, placeholder: "AB-4KM11" },
  { name: "make", label: "Make", required: true, placeholder: "Freightliner" },
  { name: "model", label: "Model", required: true, placeholder: "Cascadia" },
  { name: "year", label: "Year", type: "number", min: "1990", step: "1", placeholder: "2023", parse: (value) => (value ? Number(value) : null) },
  { name: "vin", label: "VIN", placeholder: "1FRTL20500000002" },
  { name: "safety_expiration_date", label: "Safety expiration date", type: "date" },
  { name: "ownership_type", label: "Ownership type", placeholder: "Company" },
  {
    name: "status",
    label: "Status",
    required: true,
    type: "select",
    options: [
      { label: "Active", value: "Active" },
      { label: "Maintenance", value: "Maintenance" },
      { label: "Inactive", value: "Inactive" },
    ],
  },
  { name: "notes", label: "Notes", type: "textarea", placeholder: "Maintenance notes or dispatch comments" },
];

export const TrucksPage = () => (
  <ManagementPage
    actionLabel="Add truck"
    columns={[
      { key: "truck_number", label: "Truck #" },
      { key: "unit_number", label: "Unit" },
      { key: "plate_number", label: "Plate" },
      { key: "vin", label: "VIN" },
      { key: "safety_expiration_date", label: "Safety expiry" },
      { key: "make", label: "Make" },
      { key: "model", label: "Model" },
      { key: "year", label: "Year" },
      { key: "status", label: "Status" },
    ]}
    description="Keep a simple truck roster with VIN and safety expiry so dispatch can block unsafe assignments before they happen."
    endpoint="/trucks"
    entityName="Truck"
    fields={truckFields}
    title="Trucks"
  />
);